import { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { FormFeedback } from '../FormFeedback';
import { createCategory, updateCategory } from '../../services/GuideService';

function toSlug(value) {
  return value.toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim();
}

export function CategoryForm({ category, onSaved }) {
  const isEdit = !!category;

  const [name,      setName]      = useState('');
  const [icon,      setIcon]      = useState('');
  const [slug,      setSlug]      = useState('');
  const [isEnabled, setIsEnabled] = useState(true);
  const [slugTouched, setSlugTouched] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error,      setError]      = useState(null);

  useEffect(() => {
    if (category) {
      setName(category.Name);
      setIcon(category.Icon);
      setSlug(category.Slug);
      setIsEnabled(category.IsEnabled);
      setSlugTouched(true);
    } else {
      setName('');
      setIcon('');
      setSlug('');
      setIsEnabled(true);
      setSlugTouched(false);
    }
    setError(null);
  }, [category]);

  function handleNameChange(e) {
    const val = e.target.value;
    setName(val);
    if (!slugTouched) setSlug(toSlug(val));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!name.trim() || !slug.trim()) {
      setError('Name and slug are required.');
      return;
    }
    setSubmitting(true);
    setError(null);
    try {
      const payload = { name, icon, slug, isEnabled };
      if (isEdit) {
        await updateCategory(category.Id, payload);
        onSaved({ Id: category.Id, Name: name, Icon: icon, Slug: slug, IsEnabled: isEnabled });
      } else {
        const id = await createCategory(payload);
        onSaved({ Id: Number(id), Name: name, Icon: icon, Slug: slug, IsEnabled: isEnabled, Guides: [] });
      }
    } catch {
      setError('Failed to save category. Please try again.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Form className="modal-form" onSubmit={handleSubmit}>
      <Form.Group className="mb-3" controlId="cat-name">
        <Form.Label>Name</Form.Label>
        <Form.Control
          type="text"
          placeholder="e.g. Getting Started"
          required
          value={name}
          onChange={handleNameChange}
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="cat-icon">
        <Form.Label>Icon <small className="text-muted">(Bootstrap Icons name, e.g. compass-fill)</small></Form.Label>
        <Form.Control
          type="text"
          placeholder="compass-fill"
          value={icon}
          onChange={e => setIcon(e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="cat-slug">
        <Form.Label>Slug</Form.Label>
        <Form.Control
          type="text"
          placeholder="getting-started"
          required
          value={slug}
          onChange={e => { setSlug(e.target.value); setSlugTouched(true); }}
        />
      </Form.Group>

      <Form.Check
        className="mb-3"
        type="switch"
        id="cat-enabled"
        label="Enabled (visible to public)"
        checked={isEnabled}
        onChange={e => setIsEnabled(e.target.checked)}
      />

      <FormFeedback type="error" message={error} />

      <div className="modal-form-actions">
        <Button variant="success" type="submit" disabled={submitting}>
          {submitting ? 'Saving…' : (isEdit ? 'Save Changes' : 'Create Category')}
        </Button>
      </div>
    </Form>
  );
}
